module.exports = __webpack_public_path__ + "static/media/md-cloudy-night.4cc78e92.svg";